import { useQuery } from '@tanstack/react-query'
import { Phone, PhoneIncoming, PhoneOutgoing, PhoneMissed } from 'lucide-react'
import { apiClient } from '@/lib/api.ts'
import { Link } from 'react-router-dom'
import { LoadingState } from '@/components/ui'

interface CallStats {
  total: number
  incoming: number
  outgoing: number
  missed: number
}

export default function CallsWidget() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['calls-stats-today'],
    queryFn: async () => {
      const { data } = await apiClient.get<CallStats>('/calls/stats')
      return data
    },
    refetchInterval: 30 * 1000,
  })

  if (isLoading || !stats) {
    return <LoadingState size="sm" label="" />
  }

  const items = [
    { label: 'Gesamt', value: stats.total, icon: Phone, color: 'text-gray-700' },
    { label: 'Eingehend', value: stats.incoming, icon: PhoneIncoming, color: 'text-green-600' },
    { label: 'Ausgehend', value: stats.outgoing, icon: PhoneOutgoing, color: 'text-blue-600' },
    { label: 'Verpasst', value: stats.missed, icon: PhoneMissed, color: stats.missed > 0 ? 'text-red-600' : 'text-gray-400' },
  ]

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-2">
        {items.map((item) => (
          <div key={item.label} className="flex items-center gap-2 p-2 rounded-md bg-gray-50">
            <item.icon className={`h-4 w-4 ${item.color}`} />
            <div>
              <div className={`text-body-lg font-bold ${item.color}`}>{item.value}</div>
              <div className="text-caption text-gray-500">{item.label}</div>
            </div>
          </div>
        ))}
      </div>
      {stats.missed > 0 && (
        <Link
          to="/telefonie"
          className="block text-caption text-red-600 hover:underline text-center"
        >
          {stats.missed} verpasste Anrufe - Rückrufe prüfen
        </Link>
      )}
    </div>
  )
}
